import React, { useEffect, useState } from 'react';
import Header from './Components/Header/Header'
import Body from './Components/Body/Body'
// import Footer from './Components/Footer/Footer'
import { SwmcFooter } from 'footer-component';
import './App.scss'
import Navbar from './Components/Navbar/Navbar'
import ModalContact from './Components/Contact/ModalContact'
import Fade from "react-bootstrap/Fade";
import Modal from "react-bootstrap/Modal";
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from './contexts/HyperlinkProvider';
export default function App() {
  const [modalShow, setModalShow] = useState(false);
  const handleModal = () => setModalShow(false);

  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink1, setSunWestLink1] = useState("");
  const [sunwestLink2, setSunWestLink2] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const swLink1 = await getHyperLink("websites", "swmc", 0);
      const swLink2 = await getHyperLink("websites", "swmc", 3);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setSunWestLink1(swLink1 || "Sun West");
      setSunWestLink2(swLink2 || "Sun West Mortgage Company (NMLS ID 3277)");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);
  
  useEffect(() => {
    //--Note: adding the swmc-analytics.
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    document.body.appendChild(script);
    //--end
  }, []);

  return (
   
    <>
    <div id="ModalWrapper">
          <Fade in={modalShow}>
            <Modal size="lg" show={modalShow} onHide={handleModal}>
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
              <ModalContact />
              </Modal.Body>
            </Modal>
          </Fade>
        </div>
        <Navbar setModalShow={setModalShow}/>
        <Header sunwestLink1={sunwestLink1} />
        <Body sunwestLink1={sunwestLink1} sunwestLink={sunwestLink} sunwestLink2={sunwestLink2} pavanLink={pavanLink}/>
        <SwmcFooter sunwestLink1={sunwestLink1} />
        <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
            </>
  );
}
